<template>
  <div class="parent-modal">
    <div class="modal-add">
      <div class="header">
        <slot name="header"></slot>
        <i @click="closeModal()">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="#31006F"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </i>
      </div>
      <div class="body">
        <slot name="body"></slot>
      </div>
      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
  props: {
    title: {
      default: "أضافة",
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_customizeTooltip.scss";
</style>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";
body {
  pointer-events: none !important;
}

.modal-add::-webkit-scrollbar {
  width: 0.125rem;
  height: 10.8125rem;    
  opacity: 50%;
}

.modal-add::-webkit-scrollbar-track {
  background: none;
}

.modal-add::-webkit-scrollbar-thumb {
  background: #70707052;
  opacity: 50%;
}

.close-icon {
  width: 100%;
  text-align: right;
  margin-left: 48px;
  cursor: pointer;
  height: 16px;
}

.modal-add {
  pointer-events: all;
  outline: 9999px solid rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  z-index: 999999;
  background-color: #fff;
  right: 50%;
  transform: translate(50%, -50%);
  top: 50%;
  padding: 24px 16px;
  border-radius: 24px;
  width: 450px;
  max-height: 90vh; 
  overflow: initial;

  .header {
    display: flex;
    gap: 30%;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 8px;
    margin-bottom: 24px;
    border-bottom: solid 1px #d9d9d9;
    width: 100%;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 1;

    .title {
      font-size: 20px;
      font-weight: 700;
      color: $mainColor1;
    }
    i {
      cursor: pointer;
    }
  }

  .body {
    width: 100%;
    max-height: calc(90vh - 150px);
    overflow-y: auto;
    margin-bottom: 24px;
    overflow: initial
  }

  .footer {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 16px;
    border-top: solid 1px #d9d9d9;

    button {
      padding: 8px 16px;
      font-weight: 700;
      font-size: 18px;
      line-height: 33px;
      color: #fff;
      border: none;
      background-color: $mainColor2;
      border-radius: 4px;
      cursor: pointer;
    }
    .first-btn {
      background-color: $mainColor1;
      color: #fff;
    }
  }
}
</style>
